/** @format */

import { Modal, Tooltip } from "antd";
import useUserBotList from "./hooks/useUserBotList";
import styles from "../../../styles/Components/new-dashboard/bot-performance/MoreBotsModal.module.css";
import { useState } from "react";
import {
  getRelativeTime,
  minimizeText,
} from "../../../utility/formatter-helper";
import CustomButton from "../../../ui/CustomButton";
import capitalize from "antd/es/_util/capitalize";
import BotIcon from "../../../ui/icons/BotIcon";

function MoreBotsModal({ show, setShow, onSelectBot }) {
  const { moreBots } = useUserBotList();

  // Initialize with selectedBot if available, otherwise empty object
  const [currentBot, setCurrentBot] = useState(() => {
    return JSON.parse(localStorage.getItem("selectedDashboardBot")) || {};
  });

  const closeModal = () => {
    setShow(false);
  };

  const handleSelectBot = () => {
    if (onSelectBot && Object.keys(currentBot).length > 0) {
      onSelectBot(currentBot);
    }
  };

  return (
    <Modal
      open={show}
      centered
      title={<div className={styles.modalTitle}>Select a Bot</div>}
      footer={
        onSelectBot && (
          <CustomButton
            type="primary"
            onClick={handleSelectBot}
            disabled={Object.keys(currentBot).length === 0}
            size="lg"
            className={styles.confirmButton}
          >
            Ok
          </CustomButton>
        )
      }
      onCancel={closeModal}
      className={styles.container}
      width={600}
      styles={{
        body: {
          padding: "14px 10px",
        },
        header: { marginBottom: 0 },
      }}
    >
      <div className={styles.modalContent}>
        <div className={styles.botList}>
          {moreBots.map((bot) => (
            <Tooltip
              key={bot?.bot_creation_id}
              className={`${styles.botItem} ${
                currentBot?.bot_creation_id === bot?.bot_creation_id
                  ? styles.active
                  : ""
              }`}
              onClick={() => setCurrentBot(bot)}
              title={bot?.bot_name}
              color="#0c4cfc"
            >
              <div className={styles.botName}>
                <div className={styles.botIcon}>
                  <BotIcon />
                </div>

                <h4>{minimizeText(bot?.bot_name, 10)}</h4>
              </div>
              <span>
                {capitalize(
                  bot?.exchange_id === "cryptocrispy"
                    ? "Demo Exchange"
                    : bot?.exchange_id,
                )}
              </span>
              <span>
                Created: {getRelativeTime(bot?.bot_creation_id, true)}
              </span>
              <span>{bot?.status}</span>
              <span>
                Profit: {bot?.profit_percent}
                {bot?.profit_percent !== "N/A" ? "%" : ""}
              </span>
            </Tooltip>
          ))}
        </div>
      </div>
    </Modal>
  );
}

export default MoreBotsModal;
